<template>
  <lateral-modal
    :title="$t(fileFormatModalHeader)"
    @close="closeModal"
  >
    <template slot="content">
      <div ref="dropdownContainer">
        <form
          id="diet-category-form"
          @submit.prevent="createFileFormat"
        >
          <div class="row">
            <div class="col-12">
              <div class="input--block input--block--margin">
                <label class="form--label u-required"> {{$t('company_create_mileage_category_name').toUpperCase()}}</label>
                <div
                  class="Form-file"
                  :class="{'Form--file-error': $v.fileFormat.name.$error}"
                >
                  <input
                    class="Input-text"
                    type="text"
                    v-model="fileFormat.name"
                    @blur="$v.fileFormat.name.$touch()"
                    :placeholder="$t('company_create_mileage_category_name')"
                  >
                </div>
              </div>
            </div>
            <div class="col-12 Fuell-Export--file-format">
              <p
                for=""
                class="Fuell-Text--black"
              >{{$t('company_export_settings_create_file_format_format')}}</p>
              <div
                v-for="format in fileFormats"
                :key="format.id"
                class="mb-2"
              >
                <input-radio
                  :label="format.code"
                  :value="format.id"
                  :itemValue="fileFormat.exportFormat"
                  name="exportFormat"
                  @click="setFormat(format.id)"
                ></input-radio>
              </div>
            </div>
            <div class="col-12 Fuell-Export--file-format">
              <div class="Fuell-Export--checkbox">
                <input
                  v-model="fileFormat.downloadTicket"
                  type="checkbox"
                  :true-value="true"
                  :false-value="false"
                  id="downloadTicket"
                >
                <label
                  for="downloadTicket"
                  class="Fuell-Text"
                >{{$t(`export_exportation_flow_include_tickets`)}} </label>
              </div>
            </div>
            <div class="col-12 Fuell-Export--file-format">
              <p
                for=""
                class="Fuell-Text--black"
              >{{
                $t('company_export_settings_create_file_format_columns')
              }}</p>
              <p class="Fuell-Text">
                {{$t('company_export_settings_create_file_format_columns_subtitle')}}
              </p>
              <draggable
                v-model="fileFormat.exportFields"
                draggable=".Fuell-Dragabble--column"
              >
                <div
                  v-for="(exportFieldSelected, index) in fileFormat.exportFields"
                  :key="index"
                  class="Fuell-Dragabble--column"
                >
                  <div class="d-flex flex-column Fuell-Dragabble--column--center">
                    <label
                      v-if="index === 0"
                      class="form--label pl-2"
                    >
                    </label>
                    <div class="Fuell-Draggable--icon">
                      <img
                        alt="dragable"
                        :src="require('@/assets/img/icons/icon-draggable.svg')"
                      /> {{index + 1}}
                    </div>
                  </div>

                  <div class="Fuell-Dragabble--column-content d-flex flex-column">
                    <label
                      v-if="index === 0"
                      class="form--label pl-2"
                    >
                      {{ $t('company_export_settings_create_file_format_name').toUpperCase() }}
                    </label>
                    <textarea
                      class="Input-text"
                      type="text"
                      v-model="exportFieldSelected.name"
                      :placeholder="$t('company_export_settings_create_file_format_name')"
                    ></textarea>
                  </div>
                  <div class="Fuell-Dragabble--column-content Fuell-Dragabble--column-tags d-flex flex-column multiselect-tags">
                    <label
                      v-if="index === 0"
                      class="form--label pl-2"
                    >
                      {{ $t('company_export_settings_create_file_format_data').toUpperCase() }}
                    </label>
                    <multi-select
                      :options="exportFields"
                      :placeholder="$t('company_export_settings_create_file_format_data')"
                      v-model="exportFieldSelected.data"
                      selectLabel=""
                      deselectLabel=""
                      track-by="id"
                      :customLabel="option => option.valueName || option.translatedField"
                      tag-placeholder=""
                      multiple
                      :searchable="true"
                      :showLabels="false"
                      :allow-empty="true"
                      taggable
                      :prevent-autofocus="true"
                      @select="setDataType($event)"
                      @tag="addDataType($event, exportFieldSelected)"
                      @remove="removeTag(exportFieldSelected)"
                    >
                      <div
                        class="caret"
                        slot="caret"
                        slot-scope="{ toggle }"
                        @mousedown.prevent.stop="toggle"
                      >
                        <i
                          class="Ctrl Ctrl--16"
                          aria-hidden="true"
                        >
                          <svg
                            focusable="false"
                            aria-hidden="true"
                            aria-label="Edit"
                          >
                            <use xlink:href="#dropdown-icon"></use>
                          </svg>
                        </i>
                      </div>
                      <template
                        slot="tag"
                        slot-scope="props"
                      >
                        <span
                          aria-hidden="true"
                          tabindex="1"
                          class="multiselect__tag custom--multiselect__tag"
                        >
                          <span>{{props.option.valueName || props.option.translatedField}}</span>
                          <dropdown
                            position
                            :parent="$refs.dropdownContainer"
                            :closeOnClickInside="false"
                          >
                            <div
                              v-if="props.option.format === EXPORT_FIELDS_TYPES.DATE"
                              class="dropdown-format"
                            >
                              <p class="format">
                                {{$t('company_export_settings_create_file_format_date_format')}}
                              </p>
                              <multi-select
                                v-model="props.option.valueFormat"
                                :options="valueFormats.dateFormats"
                                track-by="id"
                                :customLabel="option => option.value ? option.value.toLowerCase() : ''"
                                selectLabel=""
                                deselectLabel=""
                                tag-placeholder=""
                                :multiple="false"
                                :searchable="false"
                                :showLabels="false"
                                :allow-empty="false"
                                @input="setExample(index, props.option)"
                              ></multi-select>
                            </div>
                            <div
                              v-else-if="props.option.format === EXPORT_FIELDS_TYPES.FLOAT || props.option.format === EXPORT_FIELDS_TYPES.INTEGER"
                              class="dropdown-format"
                            >
                              <p class="format">
                                {{$t('company_export_settings_create_file_format_amount_format')}}
                              </p>
                              <multi-select
                                v-model="props.option.valueFormat"
                                :options="valueFormats.numberFormats"
                                :customLabel="option => option.value"
                                selectLabel=""
                                deselectLabel=""
                                tag-placeholder=""
                                :multiple="false"
                                :searchable="false"
                                :showLabels="false"
                                :allow-empty="false"
                                @input="setExample(index, props.option)"
                              ></multi-select>
                            </div>
                            <p
                              class="delete"
                              @click="props.remove(props.option)"
                            >
                              {{$t('company_export_settings_create_file_format_delete')}}
                            </p>
                          </dropdown>
                        </span>
                      </template>
                    </multi-select>
                  </div>
                  <div class="Fuell-Dragabble--column-content d-flex flex-column">
                    <label
                      v-if="index === 0"
                      class="form--label pl-2"
                    >
                      {{ $t('company_export_settings_create_file_format_example').toUpperCase() }}
                    </label>
                    <span
                      v-if="!exportFieldSelected.data || exportFieldSelected.data.length === 0 "
                      class="Input-text disabled"
                    >
                      {{ $t('company_export_settings_create_file_format_example') }}
                    </span>
                    <span
                      v-else
                      class="Input-text disabled"
                    >
                      <template v-for="(data, index) in exportFieldSelected.data">
                        <span
                          v-if="index + 1 < exportFieldSelected.data.length"
                          :key="index"
                        >{{data.example}} / </span>
                        <span
                          v-else
                          :key="index"
                        >{{data.example}}</span>
                      </template>
                    </span>
                  </div>
                  <div class="d-flex flex-column Fuell-Dragabble--column--center">
                    <label
                      v-if="index === 0"
                      class="form--label pl-2"
                    >
                    </label>
                    <div
                      class="close-container"
                      @click="removeColumn(index)"
                    >
                      <img
                        class="icon-close"
                        alt="icon-close"
                        :src="require('@/assets/img/icons/close-menu.svg')"
                      />
                    </div>
                  </div>
                </div>
              </draggable>
              <button
                type="button"
                @click="addColumn"
                class="Fuell-Button Fuell-Button--add-column col-12"
              >
                {{ $t('company_export_settings_create_file_format_add_column')}}
              </button>
            </div>
          </div>
        </form>
        <div
          v-if="isLoading"
          class="w-100 d-flex justify-content-center"
        >
          <spinner />
        </div>
      </div>
    </template>
    <template slot="footer">
      <button
        class="Fuell-Button blue block"
        :class="{'Fuell-Button--disabled' : !canBeSubmitted}"
        :disabled="!canBeSubmitted"
        type="submit"
        form="diet-category-form"
      >
        <span class="Fuell-Button--label">
          {{$t(fileFormatConfirmButtonLabel)}}
        </span>
      </button>
    </template>
  </lateral-modal>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { EXPORT_FIELDS_EXAMPLE } from '@/constants/exportFieldsExample'
import { EXPORT_FIELDS_TYPES } from '@/constants/exportFieldsTypes'
import draggable from 'vuedraggable'
import Dropdown from '@/components/Commons/Dropdown'
import InputRadio from '@/components/Commons/Forms/InputRadio'
import Spinner from '@/components/Commons/Spinner'
import MultiSelect from 'vue-multiselect'
import LateralModal from '@/components/Commons/Modals/LateralModal'

import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')

function initialState () {
  return {
    fileFormat: {
      name: '',
      exportFormat: null,
      exportFields: [],
      downloadTicket: false
    },
    originalFileFormat: {},
    columns: [],
    isLoading: false
  }
}

export default {
  name: 'CreateFileFormatModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: {
    draggable,
    Dropdown,
    InputRadio,
    Spinner,
    MultiSelect,
    LateralModal
  },
  props: {
    fileFormatId: {
      type: [Number, String]
    }
  },
  data () {
    return initialState()
  },
  computed: {
    canBeSubmitted () {
      return !this.$v.$invalid && this.hasLocalChanges
    },
    fileFormats () {
      return this.$store.getters['ConfigStore/privateConfig'].export_formats
    },
    fileFormatModalHeader () {
      return this.fileFormatId ? 'company_export_settings_edit_file_format_modal_header' : 'company_export_settings_create_file_format_modal_header'
    },
    fileFormatConfirmButtonLabel () {
      return this.fileFormatId ? 'company_export_settings_edit_file_format_modal_confirm' : 'company_export_settings_create_file_format_modal_confirm'
    },
    EXPORT_FIELDS_TYPES () {
      return EXPORT_FIELDS_TYPES
    },
    exportFields () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/exportFields'].fields.map(item => {
        return {
          ...item,
          translatedField: item.valueName || this.$t('export_fields_' + item.fieldLabel),
          valueFormat: undefined
        }
      })
    },
    valueFormats () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/exportFields'].valueFormats
    },
    fileFormatData () {
      return this.$store.getters['CompanyStore/ExportSettingsStore/fileFormat']
    },
    hasLocalChanges () {
      return JSON.stringify(this.fileFormat) !== JSON.stringify(this.originalFileFormat)
    }
  },
  methods: {
    setValueFormat (data) {
      if ((data.format === EXPORT_FIELDS_TYPES.INTEGER || data.format === EXPORT_FIELDS_TYPES.FLOAT) && data.valueFormat) {
        data.example = this.valueFormats.numberFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value
      } else if (data.format === EXPORT_FIELDS_TYPES.DATE && data.valueFormat) {
        if (data.valueFormat.id === 'ISO 8601') {
          data.example = this.$moment(EXPORT_FIELDS_EXAMPLE[data.format], 'DD/MM/YYYY').toISOString(this.valueFormats.dateFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value)
        } else {
          data.example = this.$moment(EXPORT_FIELDS_EXAMPLE[data.format], 'DD/MM/YYYY').format(this.valueFormats.dateFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value)
        }
      } else {
        data.example = EXPORT_FIELDS_EXAMPLE[data.format]
      }
      if (!data.valueFormat && (data.format === EXPORT_FIELDS_TYPES.INTEGER || data.format === EXPORT_FIELDS_TYPES.FLOAT)) {
        data.valueFormat = this.valueFormats.numberFormats.find(item => item.default)
      } else if (!data.valueFormat && (data.format === EXPORT_FIELDS_TYPES.DATE)) {
        data.valueFormat = this.valueFormats.dateFormats.find(item => item.default)
      }
    },
    setExample (index, data) {
      let myData = { ...data }
      if ((data.format === EXPORT_FIELDS_TYPES.INTEGER || data.format === EXPORT_FIELDS_TYPES.FLOAT) && data.valueFormat) {
        myData.example = this.valueFormats.numberFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value
      } else if (data.format === EXPORT_FIELDS_TYPES.DATE && data.valueFormat) {
        if (data.valueFormat.id === 'ISO 8601') {
          myData.example = this.$moment(EXPORT_FIELDS_EXAMPLE[data.format], 'DD/MM/YYYY').toISOString(this.valueFormats.dateFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value)
        } else {
          myData.example = this.$moment(EXPORT_FIELDS_EXAMPLE[data.format], 'DD/MM/YYYY').format(this.valueFormats.dateFormats.find(itemAux => data.valueFormat.id === itemAux.id)?.value)
        }
      } else {
        myData.example = EXPORT_FIELDS_EXAMPLE[data.format]
      }
      if (!data.valueFormat && (data.format === EXPORT_FIELDS_TYPES.INTEGER || data.format === EXPORT_FIELDS_TYPES.FLOAT)) {
        myData.valueFormat = this.valueFormats.numberFormats.find(item => item.default)
      } else if (!data.valueFormat && (data.format === EXPORT_FIELDS_TYPES.DATE)) {
        myData.valueFormat = this.valueFormats.dateFormats.find(item => item.default)
      }
      let datas = []
      this.fileFormat.exportFields[index].data.forEach(item => {
        if (item.key === myData.key) {
          datas.push(myData)
        } else {
          datas.push(item)
        }
      })
      this.$set(this.fileFormat.exportFields[index], 'data', datas)
    },
    /* allDataIsFilled () {
      let filled = true
      this.fileFormat.exportFields.forEach(exportField => {
        if (!exportField.data || exportField.data.length === 0) {
          filled = false
        } else {
          exportField.data.forEach(data => {
            if (!data || (!data.key && !data.id)) {
              filled = false
            }
          })
        }
      })
      return filled
    }, */
    initializeFileFormat () {
      this.fileFormat.name = this.fileFormatData.name
      this.fileFormat.exportFormat = this.fileFormatData.exportFormat?.id
      this.fileFormat.downloadTicket = this.fileFormatData.downloadTicket
      let exportFields = []
      this.fileFormatData.exportFields.forEach(column => {
        let exportFieldsFiltered = []
        let name = ''
        let value = ''
        column.forEach(data => {
          let enterCustom = false
          this.setValueFormat(data)
          if (!data.custom && ((data.value && data.value) || (!data.value && data.key))) {
            name = data.name
            value = data.value
            if (data.key === 'tagType') {
              data.translatedField = this.exportFields.find(item => item.value === data.value)?.translatedField
            } else {
              data.translatedField = this.exportFields.find(item => item.field === data.key)?.translatedField
            }
            exportFieldsFiltered.push(data)
          } else if (data.custom && !enterCustom) {
            name = data.name
            value = data.value
            const tag = {
              id: new Date().getTime(),
              descriptionLabel: data.value,
              field: data.value,
              fieldLabel: data.value,
              format: 'STRING',
              translatedField: data.value,
              value: data.value,
              example: EXPORT_FIELDS_EXAMPLE['STRING'],
              valueFormat: undefined
            }
            exportFieldsFiltered.push(tag)
          }
        })
        if (exportFieldsFiltered.length > 0) {
          exportFields.push({
            data: exportFieldsFiltered,
            name,
            value
          })
        }
      })
      this.fileFormat.exportFields = exportFields
      this.originalFileFormat = cloneDeep(this.fileFormat)
    },
    manageFileFormat () {
      return {
        name: this.fileFormat.name,
        exportFormat: { id: this.fileFormat.exportFormat },
        downloadTicket: this.fileFormat.downloadTicket,
        exportFields: this.fileFormat.exportFields.map(item => {
          if (item.data) {
            return item.data.map(data => {
              let valueFormat
              if (data.format === EXPORT_FIELDS_TYPES.INTEGER || data.format === EXPORT_FIELDS_TYPES.FLOAT) {
                valueFormat = { type: 'numberFormats', id: data.valueFormat?.id }
              } else if (data.format === EXPORT_FIELDS_TYPES.DATE) {
                valueFormat = { type: 'dateFormats', id: data.valueFormat?.id }
              }
              return {
                key: data.key || data.field,
                name: item.name,
                format: data.format,
                value: data.value,
                custom: data.custom || undefined,
                valueFormat: valueFormat
              }
            })
          } else {
            return [{
              custom: true,
              format: 'STRING',
              key: '',
              name: item.name,
              value: ''
            }]
          }
        })
      }
    },
    async createFileFormat () {
      if (!this.canBeSubmitted) return
      if (!this.fileFormatId) {
        await this.$store.dispatch('CompanyStore/ExportSettingsStore/createFileFormat', this.manageFileFormat())
      } else {
        await this.$store.dispatch('CompanyStore/ExportSettingsStore/updateFileFormat', { id: this.fileFormatId, info: this.manageFileFormat() })
      }
      this.closeModal()
    },
    addColumn () {
      this.fileFormat.exportFields.push([])
    },
    setDataType (field) {
      this.setValueFormat(field)
    },
    async addDataType (exportField, exportFieldSelected) {
      const tag = {
        id: new Date().getTime(),
        descriptionLabel: exportField,
        field: exportField,
        fieldLabel: exportField,
        format: 'STRING',
        translatedField: exportField,
        valueFormat: undefined,
        value: exportField,
        example: EXPORT_FIELDS_EXAMPLE['STRING'],
        custom: true
      }
      this.exportFields.push(tag)
      exportFieldSelected.data = !exportFieldSelected.data || exportFieldSelected.data?.length === 0 ? [tag] : exportFieldSelected.data.concat([tag])
      this.$forceUpdate()
    },
    removeTag (exportFieldSelected) {
      this.$forceUpdate()
    },
    setFormat (exportFormat) {
      this.fileFormat.exportFormat = exportFormat
    },
    removeColumn (index) {
      this.fileFormat.exportFields.splice(index, 1)
    },
    clearAllData () {
      Object.assign(this.$data, initialState)
    }
  },
  validations () {
    return {
      fileFormat: {
        name: { required },
        exportFormat: { required },
        exportFields: {
          required,
          $each: {
            name: { required }
          }
        }
      }
    }
  },
  async created () {
    let promises = []
    promises.push(this.$store.dispatch('CompanyStore/ExportSettingsStore/fetchExportFields'))
    if (this.fileFormatId) {
      promises.push(this.$store.dispatch('CompanyStore/ExportSettingsStore/getFileFormat', this.fileFormatId))
    }
    Promise.allSettled(promises).then(() => {
      if (this.fileFormatId) {
        this.initializeFileFormat()
      }
      this.isLoading = false
    })
  },
  unmounted () {
    this.clearAllData()
  },
  beforeRouteUpdate (to, from, next) {
    this.closeModal()
    next()
  }

}
</script>
<style lang="scss">
.Fuell-Export--file-format {
  .multiselect,
  .multiselect__tags,
  .multiselect__single {
    height: 100%;
  }
}
.custom--multiselect__tag {
  .Fuell-Dropdown .Fuell-Dropdown--button:hover {
    background-color: transparent;
  }
  .Fuell-Dropdown--container {
    width: 224px;
    .Fuell-Dropdown--content {
      padding: 0;
      text-align: left;
    }
    .multiselect,
    .multiselect__tags,
    .multiselect__single {
      height: 100%;
      height: 44px;
    }
    .dropdown-format {
      padding: 10px 12px;
      border-bottom: 1px solid var(--fill-divider);
    }
    .format {
      font-weight: 500;
      font-size: 9px;
      line-height: 12px;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: var(--text-subheading);
      margin-bottom: 4px;
    }
    .delete {
      padding: 10px 12px;
      margin-bottom: 0;
      font-weight: 500;
      font-size: 13px;
      line-height: 24px;
      color: var(--red-action-2-active);
    }
  }
}
</style>
<style scoped lang="scss">
.multiselect__tag {
  overflow: initial;
  .Fuell-Dropdown {
    position: absolute;
    right: 4px;
    top: 4px;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }
}
.Fuell-Dragabble--column .Fuell-Draggable--icon {
  margin-top: 0px;
}
.Fuell-Dragabble--column {
  display: grid;
  grid-template-columns: 48px 180px 234px 200px 12px;
  grid-auto-rows: 1fr;
  align-items: inherit;
}
.Fuell-Export--checkbox {
  input {
    min-height: auto;
    margin-right: 8px;
  }
}
.Fuell-Export--file-format {
  margin-top: 22px;
}
.form--label {
  min-height: 11px;
}
input,
textarea {
  color: var(--text-body);
  min-height: 44px;
  height: 100%;
  background-color: var(--fill-text-area);
  padding: 14px 12px;
  border-radius: 4px;
  resize: none;
}
input {
  padding: 10px 12px;
}
.Input-text.disabled {
  height: 100%;
  font-weight: 400;
  font-size: 15px;
  line-height: 24px;
  color: var(--text-body);
  border: 1px solid var(--fill-border);
  border-radius: 4px;
  padding: 10px 12px;
}
.d-flex {
  margin-right: 4px;
}
.ModalBox {
  width: 732px;
  overflow: initial;
}
.multiselect--error {
  border: 2px solid red;
  border-radius: 6px;
}
.Fuell-Button {
  display: block;
  margin-top: 9px;
  text-align: center;
  font-size: 15px;
  line-height: 24px;
  &.Fuell-Button--add-column {
    background-color: var(--blue-action-1-special-active);
    color: var(--text-link);
    &:hover {
      color: var(--text-button);
      background-color: var(--blue-action-1-special-hover);
    }
  }
}
.close-container {
  display: flex;
  width: 8px;
  height: 8px;
  margin-left: 10px;
  .icon-close {
    width: 8px;
    height: 8px;
    margin-top: 5px;
  }
}
</style>
